export default "__VITE_ASSET__BjRx4qMD__"